import moment from "moment";
import { Button, Badge } from "reactstrap";
import converter from "number-to-words";
import { Icon } from "@iconify/react";

export const getColumns = (markAsVerifiedHandler, downloadHandler) => {
  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Cell: ({ row }) => {
        return <span>{row?.original?.assessment_id}</span>;
      }
    },
    {
      Header: "assessment date",
      accessor: "created_at",
      Cell: ({ row }) => {
        return <span>{moment(`${row.original.created_at}`).format("MM-DD-YYYY")}</span>;
      }
    },
    {
      Header: "Industry",
      accessor: "industry_name",
      Cell: ({ row }) => {
        return <span className="text-capitalize">{row.original.industry_name || "N/A"}</span>;
      }
    },
    {
      Header: "Company Name",
      accessor: "company_name",
      Cell: ({ row }) => {
        return <span className="text-capitalize">{row.original.company_name || "N/A"}</span>;
      }
    },
    {
      Header: "Report",
      accessor: "version",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <Button
            outline
            color="secondary"
            size="sm"
            type="button"
            onClick={() => downloadHandler(row.original.assessment_id)}
            className="d-flex align-items-center px-2 py-1 text-capitalize"
            style={{ gap: "0.2rem" }}
          >
            <Icon icon="bx:file" width="20" height="20" />
            View Report
          </Button>
        );
      }
    }
  ];

  if (localStorage.getItem("role") === "1") {
    columns.push({
      Header: "Verified At",
      accessor: "verified_at",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.verified_at ? (
              <span>{moment(`${row.original.verified_at}`).format("MM-DD-YYYY")}</span>
            ) : (
              <div style={{ textAlign: "center" }}>---</div>
            )}
          </>
        );
      }
    });
  }

  if (
    localStorage.getItem("role") === "1" ||
    localStorage.getItem("role") === "4" ||
    localStorage.getItem("role") === "3"
  ) {
    columns.push({
      Header: "Status",
      accessor: "is_verified",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <Button
            // outline={!row.original.is_verified}
            size="sm"
            color={row.original.is_verified ? "primary" : "secondary"}
            className="py-1 d-flex align-items-center justify-content-center text-capitalize"
            style={
              row.original.is_verified
                ? {
                    backgroundColor: "#1273EB",
                    color: "#FFFFFF",
                    border: "none",
                    boxShadow: "none",
                    gap: "0.2rem",
                    width: "170px"
                  }
                : {
                    backgroundColor: "#F3F3F3",
                    color: "#808080",
                    border: "none",
                    boxShadow: "none",
                    gap: "0.2rem",
                    width: "170px"
                  }
            }
          >
            {row.original.is_verified ? (
              <Icon icon="material-symbols:star-rounded" width="20" height="20" color="#FFFFFF" />
            ) : (
              <Icon
                icon="material-symbols:star-outline-rounded"
                width="20"
                height="20"
                color="#808080"
              />
            )}
            {row.original.is_verified ? "Verified" : "Yet To Be Verified"}
          </Button>
        );
      }
    });
  }

  if (localStorage.getItem("role") === "5") {
    columns.push({
      Header: "Actions",
      accessor: "is_verified",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <Button
            color={row.original.is_verified ? "primary" : "secondary"}
            disabled={row.original.is_verified}
            onClick={() => {
              markAsVerifiedHandler(row.original.assessment_id);
            }}
            className="py-1 d-flex align-items-center justify-content-center text-capitalize"
            style={
              row.original.is_verified
                ? {
                    backgroundColor: "#1273EB",
                    color: "#FFFFFF",
                    border: "none",
                    boxShadow: "none",
                    gap: "0.2rem",
                    width: "150px"
                  }
                : {
                    backgroundColor: "#F3F3F3",
                    color: "#808080",
                    border: "none",
                    boxShadow: "none",
                    gap: "0.2rem",
                    width: "150px"
                  }
            }
            size="sm"
          >
            {row.original.is_verified ? (
              <Icon icon="material-symbols:star-rounded" width="20" height="20" color="#FFFFFF" />
            ) : (
              <Icon
                icon="material-symbols:star-outline-rounded"
                width="20"
                height="20"
                color="#808080"
              />
            )}
            {row.original.is_verified ? "Verified" : "Verify Report"}
          </Button>
        );
      }
    });
  }

  return columns;
};
